// extracted by mini-css-extract-plugin
export default {"iconsBlock":"Wevpw","icon":"TybIm","iconHabr":"GQ73n"};